/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import api from "./services/api";
import { Route } from 'react-router';
import ScrollToTop from "./components/ScrollToTop";
import { Layout } from './components/Layout';
import NavbarMain from "./components/navbars/NavbarMain";
import SimpleNavbarBcMain from "./components/navbars/SimpleNavbarBcMain";
import Breadcrumb from "./components/navbars/Breadcrumb";
import FooterMain from "./components/footers/FooterMain";
import { Home } from './components/Home';
import { LabourRequestForm, LabourRequestList } from './components/sections/LabourRequest';
import LabourRequestGrid from './components/sections/LabourRequest/LrGridV2/LabourRequestGrid';
import { TnaMatrix, TnaView, ActiveTna } from "./components/sections/TrainingNeedsAnalysis";
import Maintenance from "./components/sections/Maintenance";
import { JobOrderV2, JobOrderV1, Milestone, EditJobOrderInPage, EditJobOrderInPageAlt } from "./components/sections/LabourRequest/JobOrder";
import { loginRequest } from "./auth/authConfig";
import { Rates } from './components/sections/Rates';
import RateSheetTcView from './components/sections/RateSheetTc';
import { TermsAndConditionsList } from "./components/sections/TermsAndConditions";
import Loader from "./components/loaders";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from '@azure/msal-browser';
import ProtectedRoute from "./components/ProtectedRoute";
import Unauthorized from "./components/Unauthorized";
import { roles } from "./auth/roles";
import { CandidateList, CandidateDocuments } from "./components/sections/Candidates";
import CandidateGrid from "./components/sections/Candidates/GridV2/CandidateGrid";
import CandidatePage from "./components/sections/Candidates/EditorPage";
import { ContractTermView } from "./components/sections/ContractTerm";
import { ProjectContractTermList } from "./components/sections/ProjectContractTerm";
import { ProjectContractTemplateList } from "./components/sections/ProjectContractTemplate";
import { EntityContractTemplateList } from "./components/sections/EntityContractTemplate";
import { CrewList } from "./components/sections/Crews";
import { AccommodationList } from "./components/sections/Accommodation";
import { RosterList, CandidateLocationReport, CreateNewWithoutForecast } from "./components/sections/Roster";
import { Forecast as Forecast2, Grid as ForecastGrid, ForecastWizard, RosterWizard } from "./components/sections/Forecasting";
import TnaDRGridJobOrder from './components/sections/LabourRequest/JobOrder/TNADiscrepancyReportV2/TnaDRGridJobOrder';
import JobOrderTNADiscrepancyReport from './components/sections/LabourRequest/JobOrder/TNADiscrepancyReport';
import RosterCandidateAllocation from './components/reports/RosterCandidateAllocation';
import RosterExport from './components/reports/RosterExport';
import CommunicationGrid from "./components/sections/Communication/GridV2/CommunicationGrid"
import { CommunicationList } from "./components/sections/Communication";
import RosterTNADiscrepancyReport from './components/sections/Roster/TNADiscrepancyReport';
import TnaDRGrid from './components/sections/Roster/TNADiscrepancyReportV2/TnaDRGrid';
import RosterSiteExport from './components/reports/RosterSiteExport';
import RosterTNAExport from './components/reports/RosterTNAExport';
import Grid from './components/sections/RosterV2/Grid';
import ReportCentreList from './components/sections/ReportCentre/List';
import GenericReport from './components/reports/GenericReport';
import { RosterProvider } from "./components/sections/RosterV2/contexts/RosterContext";
import AllRosterGrid from "./components/sections/Roster/AllRosterGrid/AllRosterGrid";
import { RosterProvider as RosterProvider_AllRosterGrid } from "./components/sections/Roster/AllRosterGrid/contexts/RosterContext";
import { ForecastProvider } from "./components/sections/Forecasting/contexts/ForecastContext";
import "./assets/css/custom.css";
import PortalUserList from './components/sections/Candidates/PortalUserList';
import CandidateMergeDialog from './components/sections/Candidates/DataMerge';
import ReviewRequestList from './components/sections/LabourRequest/ReviewRequestList';
import ReviewRequestDetail from './components/sections/LabourRequest/ReviewRequestDetail';
import LabourRequestApprovalList from './components/sections/LabourRequest/Approval/LabourRequestApprovalList';
import { AppProvider } from './contexts/AppProvider';
import { JobOrderProvider } from "./components/sections/LabourRequest/JobOrder/GridV2/contexts/JobOrderContext";
import { ReportProvider as RosterAccommodationReportProvider } from "./components/sections/RosterV2/reports/contexts/ReportContext";
import RosterAccommodationReport from './components/sections/RosterV2/reports/RosterAccommodationReport';
import { GridProvider as RosterEmptySlotsProvider } from "./components/sections/RosterV2/pages/EmptySlots/contexts/GridContext";
import RosterEmptySlot from './components/sections/RosterV2/pages/EmptySlots/RosterEmptySlotGrid';
import LRFDetailList from './components/sections/LabourRequest/JobOrder/LRFDetailList';
import JobOrderMilestoneEditor from './components/sections/LabourRequest/JobOrder/JobOrderMilestoneEditor';
import { MergeProjectsEditor as RosterMergeProjectsEditor } from './components/sections/RosterV2/pages/MergeProjects';
import { ECCApprovalListV2, ECCFormApprovalV2, ECCFormSubmissionV2, ECCInitialForm, ECCListV2 } from './components/sections/EmployeeChangeConditionV2';
import TerminationInitialForm from './components/sections/EmployeeChangeConditionV2/Termination/TerminationInitialForm';
import TerminationFinalForm from './components/sections/EmployeeChangeConditionV2/Termination/TerminationFinalForm';

const AllRosterGridProvider = (props) => <RosterProvider_AllRosterGrid><AllRosterGrid {...props} /></RosterProvider_AllRosterGrid>;
const RosterGrid = (props) => <RosterProvider><Grid {...props} /></RosterProvider>;
const JobOrderGrid = (props) => <JobOrderProvider><JobOrderV2 {...props} /></JobOrderProvider>;
const RosterAccommodationReportGrid = (props) => <RosterAccommodationReportProvider><RosterAccommodationReport {...props} /></RosterAccommodationReportProvider>;
const RosterEmptySlotGrid = (props) => <RosterEmptySlotsProvider><RosterEmptySlot {...props} /></RosterEmptySlotsProvider>;
//const ForecastGrid = (props) => <ForecastProvider><Forecast {...props} /></ForecastProvider>;

export default function App(props) {

    const { login, result, error } = useMsalAuthentication(InteractionType.Redirect, loginRequest);
    const { instance, accounts, inProgress } = useMsal();

    /*********************************************************************************************/
    /* Don't reapeat this code. Needed for workaround only. Refactoring of Roster needs to occur */
    /*********************************************************************************************/
    const [rosterLookups, setRosterLookups] = useState({ shifts: [], siteTravelTypes: [], pointOfHires: [] });
    useEffect(() => {
        const apiCalls = [
            api.get(`/lookup/shift`),
            api.get(`/lookup/sitetraveltype`),
            api.get(`/lookup/pointofhire`),
        ];
        Promise.all(apiCalls)
            .then((response) => setRosterLookups({
                shifts: response[0].data,
                siteTravelTypes: response[1].data,
                pointOfHires: response[2].data,
            }))
            .catch((error) => console.log(error.response));
    }, []);
    /*******/
    /* End */
    /*******/

    return (
        <AppProvider>
            <Layout>
                <AuthenticatedTemplate>
                    <ScrollToTop />
                    <>
                        <SimpleNavbarBcMain
                            type="red"
                            noMenu
                            directions={[
                                // {
                                //     key: "rosterwizard",
                                //     value: "Roster Wizard - Create Roster Template Mapping"
                                // },
                                // {
                                //     key: "rosterwizardfinal",
                                //     value: "Roster Wizard - Assign Resources"
                                // },
                                {
                                    key: "roster",
                                    value: "Manage Roster"
                                },
                                {
                                    key: "rosteremptyslots",
                                    value: "Roster Empty Slots"
                                },
                                {
                                    key: "all-roster-grid",
                                    value: "ALl Roster Grid"
                                },
                                {
                                    key: "roster-create-new-without-forecast",
                                    value: "Create New Roster without Forecast"
                                },
                                {
                                    key: "lrf",
                                    value: "Labour Request Form",
                                    customRedirect: "/lrflist"
                                },
                                {
                                    key: "lrflist",
                                    value: "Labour Request List"
                                },
                                {
                                    key: "tnadiscrepancy-joborder",
                                    value: "TNA Discrepancy Report"
                                },
                                {
                                    key: "tnadiscrepancy-roster",
                                    value: "TNA Discrepancy Report"
                                },
                                {
                                    key: "joborder",
                                    value: "Job Order"
                                },
                                {
                                    key: "joborderdetail",
                                    value: "Job Order",
                                    customRedirect: "/joborder"
                                },
                                {
                                    key: "joborderlrfdetails",
                                    value: "Job Order",
                                    customRedirect: "/joborder"
                                },
                                {
                                    key: "jobordermilestone",
                                    value: "Job Order Milestone",
                                    customRedirect: "/joborder"
                                },
                                {
                                    key: "reportcentre",
                                    value: "Report Centre"
                                },
                                {
                                    key: "reportviewer",
                                    value: "Report Centre",
                                    customRedirect: "/reportcentre"
                                },
                                {
                                    key: "talent",
                                    value: "Talents",
                                    customRedirect: "/talents"
                                },
                                {
                                    key: "portalusers",
                                    value: "Portal Users",
                                    customRedirect: "/talents"
                                },
                                {
                                    key: "lrfreview",
                                    value: "Application Review Requests",
                                },
                                {
                                    key: "lrfreviewdetail",
                                    value: "Application Review Requests",
                                    customRedirect: "/lrfreview",
                                },
                                {
                                    key: "lrfapproval",
                                    value: "Labour Request Approval",
                                },
                                {
                                    key: "lrfapprovaldetail",
                                    value: "Labour Request Approval",
                                    customRedirect: "/lrfapproval",
                                },
                                {
                                    key: "rosteraccommodationreport",
                                    value: "Roster Accommodation Report",
                                },
                                {
                                    key: "ecclist",
                                    value: "Employee Change Condition List",
                                },
                                {
                                    key: "eccform",
                                    value: "Employee Change Condition Form",
                                    customRedirect: "/ecclist?mode=ecc",
                                },
                                {
                                    key: "eccinitialform",
                                    value: "Employee Change Condition Form",
                                    customRedirect: "/ecclist?mode=ecc",
                                },
                                {
                                    key: "eccapprovallist",
                                    value: "ECC Approval List",
                                },
                                {
                                    key: "eccapproval",
                                    value: "ECC Approval List",
                                    customRedirect: "/eccapprovallist?mode=ecc",
                                    key: "exitlist",
                                    value: "Exit Form List",
                                },
                                {
                                    key: "exitformapproval",
                                    value: "Exit Form Approval",
                                    customRedirect: "/eccapprovallist?mode=exit",
                                },
                                {
                                    key: "exitform",
                                    value: "Exit Form",
                                    customRedirect: "/ecclist?mode=exit",
                                },
                                {
                                    key: "exitformfinal",
                                    value: "Exit Form Final",
                                    customRedirect: "/ecclist?mode=exit",
                                },
                                {
                                    key: "rostermergeprojects",
                                    value: "Merge Projects",
                                },
                            ]}
                        />
                        {/* 
                    <NavbarMain type="white" noMenu />
                    <Breadcrumb
                        directions={[
                            {
                                key: "rosterwizard",
                                value: "Roster Wizard - Create Roster Template Mapping"
                            },
                            {
                                key: "rosterwizardfinal",
                                value: "Roster Wizard - Assign Resources"
                            },
                            {
                                key: "roster",
                                value: "Manage Roster"
                            },
                            {
                                key: "all-roster-grid",
                                value: "ALl Roster Grid"
                            },
                            {
                                key: "roster-create-new-without-forecast",
                                value: "Create New Roster without Forecast"
                            },
                            {
                                key: "lrf",
                                value: "Labour Request Form",
                                customRedirect: "/lrflist"
                            },
                            {
                                key: "lrflist",
                                value: "Labour Request Forms - List"
                            },
                            {
                                key: "tnadiscrepancy-joborder",
                                value: "TNA Discrepancy Report"
                            },
                            {
                                key: "tnadiscrepancy-roster",
                                value: "TNA Discrepancy Report"
                            },
                            {
                                key: "joborder",
                                value: "Job Order"
                            },
                            {
                                key: "joborderdetail",
                                value: "Job Order",
                                customRedirect: "/joborder"
                            },
                            {
                                key: "reportcentre",
                                value: "Report Centre"
                            },
                            {
                                key: "reportviewer",
                                value: "Report Centre",
                                customRedirect: "/reportcentre"
                            },
                            {
                                key: "talent",
                                value: "Talents",
                                customRedirect: "/talents"
                            },
                            {
                                key: "portalusers",
                                value: "Portal Users",
                                customRedirect: "/talents"
                            },
                            {
                                key: "lrfreview",
                                value: "Application Review Requests",
                            },
                            {
                                key: "lrfreviewdetail",
                                value: "Application Review Requests",
                                customRedirect: "/lrfreview",
                            },
                            {
                                key: "lrfapproval",
                                value: "Labour Request Approval",
                            },
                            {
                                key: "lrfapprovaldetail",
                                value: "Labour Request Approval",
                                customRedirect: "/lrfapproval",
                            },
                        ]}
                    />
                    */}
                        <Route exact path='/' component={Home} />
                        <Route exact path='/unauthorized' component={Unauthorized} />
                        <ProtectedRoute path='/lrf/:id?' component={LabourRequestForm} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin, roles.HR]} />
                        <ProtectedRoute path='/lrflist/:skip?/:take?' component={LabourRequestGrid} allowedRoles={[roles.Recruitment, roles.HR, roles.Manager, roles.Admin]} />
                        {/* <ProtectedRoute path='/lrflistV1/:skip?/:take?' component={LabourRequestList} allowedRoles={[roles.Recruitment, roles.HR, roles.Manager, roles.PlanningMobilisation, roles.Admin]} /> */}
                        <ProtectedRoute path='/lrfreview' component={ReviewRequestList} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin]} />
                        <ProtectedRoute path='/lrfreviewdetail/:id' component={ReviewRequestDetail} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin]} />
                        <ProtectedRoute path='/lrfapproval' component={LabourRequestApprovalList} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin]} />
                        <ProtectedRoute path='/lrfapprovaldetail/:id?' component={LabourRequestForm} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin]} />

                        <ProtectedRoute path='/tna/:id?' component={TnaView} allowedRoles={[roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/activetna' component={ActiveTna} allowedRoles={[roles.HR, roles.Admin]} />
                        {/* <ProtectedRoute path='/matrix' component={TnaMatrix} allowedRoles={[roles.Recruitment]} /> */}

                    {/* <ProtectedRoute path='/maintenance/trainingmaster' component={TrainingMaster} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin]} /> */}
                        <ProtectedRoute path='/maintenance/:selected?/:mode?/:id?' component={Maintenance} allowedRoles={[roles.HR, roles.Admin, roles.Maintenance]} />
                        <ProtectedRoute path='/rates/:projectId?' component={RateSheetTcView} allowedRoles={[roles.HR, roles.Admin]} />
                    {/* <ProtectedRoute path='/terms' component={TermsAndConditionsList} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin]} />  */}
                        <ProtectedRoute path='/milestone/:requestId(\d+)?/:action(\D+)?' component={Milestone} allowedRoles={[roles.Recruitment, roles.HR, roles.Admin]} />

                        <ProtectedRoute path='/joborderdetail/:fpJobOrderId' component={JobOrderV2} allowedRoles={[roles.Recruitment, roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/joborder/:requestId(\d+)?/:action(\D+)?' component={JobOrderGrid} allowedRoles={[roles.Recruitment, roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/joborderlrfdetails/:requestId(\d+)' component={LRFDetailList} allowedRoles={[roles.Recruitment, roles.HR, roles.Admin]} />
                        {/* <ProtectedRoute path='/joborderV1/:requestId(\d+)?/:action(\D+)?' component={JobOrderV1} allowedRoles={[roles.Recruitment, roles.HR, roles.Admin]} /> */}
                        <ProtectedRoute path='/jobordermilestone/:jobOrderId' component={JobOrderMilestoneEditor} allowedRoles={[roles.Recruitment, roles.HR, roles.Admin]} />
                    {/* <ProtectedRoute path='/joborder' component={JobOrder} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin]} /> 

                        <ProtectedRoute path='/joborder/:requestId?' component={JobOrder} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin]}  />  */}
                        <ProtectedRoute path='/talents/:id?' exact component={CandidateGrid} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Talent, roles.Admin]} />
                        {/* <ProtectedRoute path='/talentsV1/:id?' exact component={CandidateList} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Admin]} /> */}
                        <ProtectedRoute path='/talents/:id/docs' component={CandidateDocuments} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Talent, roles.Admin]} />
                        <ProtectedRoute path='/talent/:id' exact component={CandidatePage} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Talent, roles.Admin]} />
                        <ProtectedRoute path='/talents/merge/wizard' component={CandidateMergeDialog} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Admin]} />

                        <ProtectedRoute path='/contractterm' component={ContractTermView} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Admin]} />
                        <ProtectedRoute path='/projectterm' component={ProjectContractTermList} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Admin]} />
                        <ProtectedRoute path='/pct/:projectId?' component={ProjectContractTemplateList} allowedRoles={[roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/ect/:entityId?' component={EntityContractTemplateList} allowedRoles={[roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/accommodation' component={AccommodationList} allowedRoles={[roles.Recruitment, roles.Admin]} />
                        <ProtectedRoute path='/employeelocreport' component={CandidateLocationReport} allowedRoles={[roles.Recruitment, roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/tnadiscrepancy-joborder/:id' component={TnaDRGridJobOrder} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Admin]} />
                        {/* <ProtectedRoute path='/tnadiscrepancy-joborderV1/:id' component={JobOrderTNADiscrepancyReport} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Admin]} /> */}
                        <ProtectedRoute path='/reports/rostercandidateallocation' component={RosterCandidateAllocation} allowedRoles={[roles.Recruitment, roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/reports/rosterexport' component={RosterExport} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin]} />

                        <ProtectedRoute path='/communication' component={CommunicationGrid} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Admin]} />
                        {/* <ProtectedRoute path='/communicationV1' component={CommunicationList} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Admin]} /> */}
                        
                        {/* <ProtectedRoute path='/portalusers' component={PortalUserList} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Admin]} /> */}

                        {/* <ProtectedRoute path='/forecasting' component={ForecastGrid} allowedRoles={[roles.PlanningMobilisation, roles.Spc, roles.Admin]} />
                        <ProtectedRoute path='/forecasting_old' component={Forecast2} allowedRoles={[roles.PlanningMobilisation, roles.Admin]} />
                        <ProtectedRoute path='/rosterwizard' component={ForecastWizard} allowedRoles={[roles.PlanningMobilisation, roles.Admin]} />
                        <ProtectedRoute path='/rosterwizardfinal' component={RosterWizard} allowedRoles={[roles.PlanningMobilisation, roles.Admin]} /> */}

                        {/* <ProtectedRoute path='/aggrid' component={Grid} allowedRoles={[roles.Recruitment, roles.Manager, roles.Admin]}  /> */}
                        <ProtectedRoute path='/roster' component={RosterGrid} allowedRoles={[roles.Recruitment, roles.Spc, roles.PlanningMobilisation, roles.HR, roles.Admin]} {...rosterLookups} />
                        <ProtectedRoute path='/rosteremptyslots' component={RosterEmptySlotGrid} allowedRoles={[roles.PlanningMobilisation, roles.Admin]} {...rosterLookups} />
                        <ProtectedRoute path='/rosteraccommodationreport' component={RosterAccommodationReportGrid} allowedRoles={[roles.PlanningMobilisation, roles.Admin]} />
                        <ProtectedRoute path='/all-roster-grid' component={AllRosterGridProvider} allowedRoles={[roles.PlanningMobilisation, roles.Admin]} />
                        <ProtectedRoute path='/roster-create-new-without-forecast' component={CreateNewWithoutForecast} allowedRoles={[roles.PlanningMobilisation, roles.Admin]} />
                        <ProtectedRoute path='/rostermergeprojects' component={RosterMergeProjectsEditor} allowedRoles={[roles.PlanningMobilisation, roles.Admin]} />

                        <ProtectedRoute path='/reportcentre' component={ReportCentreList} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Reports, roles.Admin]} />
                        <ProtectedRoute path='/reportviewer/:reportName' component={GenericReport} allowedRoles={[roles.Recruitment, roles.HR, roles.PlanningMobilisation, roles.Reports, roles.Admin]} />
                        {/* <FooterMain /> */}
                        
                        <ProtectedRoute path='/ecclist' component={ECCListV2} allowedRoles={[roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/eccinitialform' component={ECCInitialForm} allowedRoles={[roles.HR, roles.Manager, roles.Admin]} />
                        <ProtectedRoute path='/eccform/:id' component={ECCFormSubmissionV2} allowedRoles={[roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/eccapprovallist' component={ECCApprovalListV2} allowedRoles={[roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/eccapproval/:id' component={ECCFormApprovalV2} allowedRoles={[roles.HR, roles.Manager, roles.Admin]} />
                        <ProtectedRoute path='/exitform/:id' component={TerminationInitialForm} allowedRoles={[roles.HR, roles.Admin]} />
                        <ProtectedRoute path='/exitformfinal/:id' component={TerminationFinalForm} allowedRoles={[roles.HR, roles.Manager, roles.Admin]} />
                        <ProtectedRoute path='/exitformapproval/:id/:approvalId' component={TerminationFinalForm} allowedRoles={[roles.HR, roles.Manager, roles.Admin]} />
                    </>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <Loader />
                </UnauthenticatedTemplate>
            </Layout>
        </AppProvider>
    )
}
